import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'

import InDmImage from '@/client/components/_atoms/in_dm_image'
import { useErrorState } from '@/client/components/_hooks/useErrorState'

interface Props {
  url: string
  mediaType: 'image' | 'video'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmMedia',
  props: {
    url: null,
    mediaType: null
  },
  setup(__props: any) {

const props = __props as {
  url: string
  mediaType: 'image' | 'video'
};



const { hasError: isVideoError, onError: onVideoError } = useErrorState()
const isVideo = computed(() => props.mediaType === 'video')
const videoRef = ref<HTMLVideoElement | null>(null)

onMounted(() => {
  if (videoRef.value) {
    videoRef.value.muted = true
  }
})

return { __sfc: true,props, isVideoError, onVideoError, isVideo, videoRef, InDmImage }
}

})